// Shared taxonomy and team data — used by GenrePicker (publisher side) and InterestPickerModal (reader side).
// TEAM_LISTS keys match the league keys in TAXONOMY so lookups are direct.

export const TEAM_LISTS = {
  NFL: [
    'Arizona Cardinals', 'Atlanta Falcons', 'Baltimore Ravens', 'Buffalo Bills', 'Carolina Panthers', 'Chicago Bears',
    'Cincinnati Bengals', 'Cleveland Browns', 'Dallas Cowboys', 'Denver Broncos', 'Detroit Lions', 'Green Bay Packers',
    'Houston Texans', 'Indianapolis Colts', 'Jacksonville Jaguars', 'Kansas City Chiefs', 'Las Vegas Raiders', 'Los Angeles Chargers',
    'Los Angeles Rams', 'Miami Dolphins', 'Minnesota Vikings', 'New England Patriots', 'New Orleans Saints', 'New York Giants',
    'New York Jets', 'Philadelphia Eagles', 'Pittsburgh Steelers', 'San Francisco 49ers', 'Seattle Seahawks', 'Tampa Bay Buccaneers',
    'Tennessee Titans', 'Washington Commanders',
  ],

  MLB: [
    'Arizona Diamondbacks', 'Atlanta Braves', 'Baltimore Orioles', 'Boston Red Sox', 'Chicago Cubs', 'Chicago White Sox',
    'Cincinnati Reds', 'Cleveland Guardians', 'Colorado Rockies', 'Detroit Tigers', 'Houston Astros', 'Kansas City Royals',
    'Los Angeles Angels', 'Los Angeles Dodgers', 'Miami Marlins', 'Milwaukee Brewers', 'Minnesota Twins', 'New York Mets',
    'New York Yankees', 'Oakland Athletics', 'Philadelphia Phillies', 'Pittsburgh Pirates', 'San Diego Padres', 'San Francisco Giants',
    'Seattle Mariners', 'St. Louis Cardinals', 'Tampa Bay Rays', 'Texas Rangers', 'Toronto Blue Jays', 'Washington Nationals',
  ],

  NBA: [
    'Atlanta Hawks', 'Boston Celtics', 'Brooklyn Nets', 'Charlotte Hornets', 'Chicago Bulls', 'Cleveland Cavaliers',
    'Dallas Mavericks', 'Denver Nuggets', 'Detroit Pistons', 'Golden State Warriors', 'Houston Rockets', 'Indiana Pacers',
    'Los Angeles Clippers', 'Los Angeles Lakers', 'Memphis Grizzlies', 'Miami Heat', 'Milwaukee Bucks', 'Minnesota Timberwolves',
    'New Orleans Pelicans', 'New York Knicks', 'Oklahoma City Thunder', 'Orlando Magic', 'Philadelphia 76ers', 'Phoenix Suns',
    'Portland Trail Blazers', 'Sacramento Kings', 'San Antonio Spurs', 'Toronto Raptors', 'Utah Jazz', 'Washington Wizards',
  ],

  WNBA: [
    'Atlanta Dream', 'Chicago Sky', 'Connecticut Sun', 'Dallas Wings', 'Golden State Valkyries', 'Indiana Fever',
    'Las Vegas Aces', 'Los Angeles Sparks', 'Minnesota Lynx', 'New York Liberty', 'Phoenix Mercury', 'Seattle Storm',
    'Washington Mystics',
  ],

  'NCAA (College Football)': [
    'Air Force', 'Akron', 'Alabama', 'App State', 'Arizona', 'Arizona State',
    'Arkansas', 'Arkansas State', 'Army', 'Auburn', 'Ball State', 'Baylor',
    'Boise State', 'Boston College', 'Bowling Green', 'Buffalo', 'BYU', 'California',
    'Central Michigan', 'Charlotte', 'Cincinnati', 'Clemson', 'Coastal Carolina', 'Colorado',
    'Colorado State', 'Duke', 'East Carolina', 'Eastern Michigan', 'FAU', 'FIU',
    'Florida', 'Florida State', 'Fresno State', 'Georgia', 'Georgia Southern', 'Georgia State',
    'Georgia Tech', 'Hawaii', 'Houston', 'Illinois', 'Indiana', 'Iowa',
    'Iowa State', 'Jacksonville State', 'James Madison', 'Kansas', 'Kansas State', 'Kent State',
    'Kentucky', 'Liberty', 'Louisiana', 'Louisiana Monroe', 'Louisiana Tech', 'Louisville',
    'LSU', 'Marshall', 'Maryland', 'Memphis', 'Miami (FL)', 'Miami (OH)',
    'Michigan', 'Michigan State', 'Middle Tennessee', 'Minnesota', 'Mississippi State', 'Missouri',
    'Navy', 'NC State', 'Nebraska', 'Nevada', 'New Mexico', 'New Mexico State',
    'North Carolina', 'North Texas', 'Northern Illinois', 'Northwestern', 'Notre Dame', 'Ohio',
    'Ohio State', 'Oklahoma', 'Oklahoma State', 'Old Dominion', 'Ole Miss', 'Oregon',
    'Penn State', 'Pittsburgh', 'Purdue', 'Rice', 'Rutgers', 'Sam Houston',
    'San Diego State', 'San Jose State', 'SMU', 'South Alabama', 'South Carolina', 'South Florida',
    'Southern Miss', 'Stanford', 'Syracuse', 'TCU', 'Temple', 'Tennessee',
    'Texas', 'Texas A&M', 'Texas State', 'Texas Tech', 'Toledo', 'Troy',
    'Tulane', 'Tulsa', 'UAB', 'UCF', 'UCLA', 'UNLV',
    'USC', 'Utah', 'Utah State', 'UTEP', 'UTSA', 'Vanderbilt',
    'Virginia', 'Virginia Tech', 'Wake Forest', 'Washington', 'West Virginia', 'Western Kentucky',
    'Western Michigan', 'Wisconsin', 'Wyoming',
  ],

  "NCAA (Men's Basketball)": [
    'Alabama', 'Arizona', 'Arizona State', 'Arkansas', 'Auburn', 'Baylor',
    'Boston College', 'Butler', 'BYU', 'California', 'Cincinnati', 'Clemson',
    'Colorado', 'Connecticut', 'Creighton', 'Dayton', 'DePaul', 'Drake',
    'Duke', 'Florida', 'Florida State', 'Georgetown', 'Georgia', 'Georgia Tech',
    'Gonzaga', 'Houston', 'Illinois', 'Indiana', 'Iowa', 'Iowa State',
    'Kansas', 'Kansas State', 'Kentucky', 'Louisville', 'Loyola Chicago', 'LSU',
    'Marquette', 'Maryland', 'Memphis', 'Miami (FL)', 'Michigan', 'Michigan State',
    'Minnesota', 'Mississippi State', 'Missouri', 'Murray State', 'NC State', 'Nebraska',
    'North Carolina', 'Northwestern', 'Notre Dame', 'Ohio State', 'Oklahoma', 'Oklahoma State',
    'Ole Miss', 'Oregon', 'Penn State', 'Pittsburgh', 'Providence', 'Purdue',
    'Rutgers', "Saint Mary's", 'San Diego State', 'Seton Hall', 'SMU', 'South Carolina',
    "St. John's", 'Stanford', 'Syracuse', 'TCU', 'Tennessee', 'Texas',
    'Texas A&M', 'Texas Tech', 'UCF', 'UCLA', 'USC', 'Utah',
    'Vanderbilt', 'VCU', 'Villanova', 'Virginia', 'Virginia Tech', 'Wake Forest',
    'Washington', 'West Virginia', 'Wichita State', 'Wisconsin', 'Xavier',
  ],

  "NCAA (Women's Basketball)": [
    'Alabama', 'Arizona', 'Arizona State', 'Arkansas', 'Auburn', 'Baylor',
    'Boston College', 'BYU', 'California', 'Cincinnati', 'Clemson', 'Colorado',
    'Connecticut', 'Creighton', 'Dayton', 'DePaul', 'Duke', 'Florida',
    'Florida State', 'Georgetown', 'Georgia', 'Georgia Tech', 'Gonzaga', 'Houston',
    'Illinois', 'Indiana', 'Iowa', 'Iowa State', 'Kansas', 'Kansas State',
    'Kentucky', 'Long Beach State', 'Louisville', 'LSU', 'Marquette', 'Maryland',
    'Miami (FL)', 'Michigan', 'Michigan State', 'Minnesota', 'Mississippi State', 'Missouri',
    'NC State', 'Nebraska', 'North Carolina', 'Northwestern', 'Notre Dame', 'Ohio State',
    'Oklahoma', 'Oklahoma State', 'Ole Miss', 'Oregon', 'Oregon State', 'Penn State',
    'Pittsburgh', 'Providence', 'Purdue', 'Rutgers', 'San Diego State', 'Seton Hall',
    'SMU', 'South Carolina', 'South Florida', "St. John's", 'Stanford', 'Syracuse',
    'TCU', 'Tennessee', 'Texas', 'Texas A&M', 'Texas Tech', 'UCF',
    'UCLA', 'UNLV', 'USC', 'Utah', 'Utah State', 'Vanderbilt',
    'Villanova', 'Virginia', 'Virginia Tech', 'Wake Forest', 'Washington', 'West Virginia',
    'Wisconsin', 'Xavier',
  ],

  'NCAA (College Baseball)': [
    'Alabama', 'Arizona', 'Arizona State', 'Arkansas', 'Auburn', 'Baylor',
    'Cal State Fullerton', 'Clemson', 'Dallas Baptist', 'Duke', 'Florida', 'Florida State',
    'Georgia', 'Georgia Tech', 'Gonzaga', 'Houston', 'Illinois', 'Indiana',
    'Iowa', 'Kansas', 'Kansas State', 'Kentucky', 'Long Beach State', 'Louisville',
    'LSU', 'Maryland', 'Miami (FL)', 'Michigan', 'Michigan State', 'Minnesota',
    'Mississippi State', 'Missouri', 'NC State', 'Nebraska', 'North Carolina', 'Northwestern',
    'Notre Dame', 'Ohio State', 'Oklahoma', 'Oklahoma State', 'Ole Miss', 'Oregon State',
    'Penn State', 'Pepperdine', 'Pittsburgh', 'Purdue', 'Rutgers', 'South Carolina',
    'Stanford', 'TCU', 'Tennessee', 'Texas', 'Texas A&M', 'Texas Tech',
    'UCLA', 'USC', 'Vanderbilt', 'Virginia', 'Virginia Tech', 'Wake Forest',
    'Washington State', 'West Virginia',
  ],

  'NCAA (Softball)': [
    'Alabama', 'Arizona', 'Arizona State', 'Arkansas', 'Auburn', 'Baylor',
    'Boston College', 'BYU', 'Cal', 'Clemson', 'Duke', 'Florida',
    'Florida Atlantic', 'Florida State', 'Fresno State', 'Georgia', 'Georgia Tech', 'Houston',
    'Indiana', 'Iowa', 'Iowa State', 'Kansas', 'Kentucky', 'Louisiana',
    'Louisville', 'LSU', 'Maryland', 'Miami (FL)', 'Michigan', 'Michigan State',
    'Minnesota', 'Mississippi State', 'Missouri', 'NC State', 'Nebraska', 'Nevada',
    'North Carolina', 'Northwestern', 'Notre Dame', 'Ohio State', 'Oklahoma', 'Oklahoma State',
    'Ole Miss', 'Oregon', 'Oregon State', 'Penn State', 'Pittsburgh', 'Purdue',
    'Rutgers', 'San Jose State', 'South Alabama', 'South Carolina', 'Southern Miss', 'Stanford',
    'Syracuse', 'Tennessee', 'Texas', 'Texas A&M', 'Texas Tech', 'Troy',
    'UAB', 'UCF', 'UCLA', 'USC', 'Utah', 'Utah State',
    'Vanderbilt', 'Virginia', 'Virginia Tech', 'Washington', 'Washington State', 'West Virginia',
    'Western Kentucky', 'Wisconsin',
  ],
};

// Full genre taxonomy — used by GenrePicker (publisher) and InterestPickerModal (reader).
// For sports leagues with team rosters, the leaf array contains 'Specific Team' as a sentinel.
// When 'Specific Team' is selected, the picker shows a team dropdown from TEAM_LISTS[leagueName].
// The saved path omits 'Specific Team': NFL › Dallas Cowboys (not NFL › Specific Team › Dallas Cowboys).
export const TAXONOMY = {
  Politics: {
    'Elections & Campaigns': {
      'Primary Elections': ['Candidate Profiles & Debates', 'Polling & Forecasting', 'Other'],
      'General Elections': ['Voter Turnout & Suppression', 'Electoral College / Runoffs', 'Other'],
      'Campaign Finance': ['PACs & Super PACs', 'Donor Networks', 'Other'],
      Other: [],
    },
    'Government & Policy': {
      'Legislative Branch': ['Bills, Resolutions & Hearings', 'Budget & Appropriations', 'Other'],
      'Executive Branch': ['Presidential Actions & Orders', 'Cabinet & Federal Agencies', 'Other'],
      'Judicial Branch': ['Supreme Court Rulings', 'Federal & Circuit Courts', 'Other'],
      Other: [],
    },
    'International Relations': {
      'Diplomacy & Foreign Policy': ['Other'],
      'Sanctions & Trade Policy': ['Other'],
      'Treaties & Multilateral Agreements': ['Other'],
      Other: [],
    },
    'Political Parties & Ideology': {
      'Party Platforms & Infighting': ['Other'],
      'Leadership Contests': ['Other'],
      Other: [],
    },
    Other: {},
  },

  'Business & Economy': {
    'Markets & Finance': {
      'Stock Markets': ['Equities & Indices', 'IPOs & SPACs', 'Other'],
      Commodities: ['Energy (Oil, Gas, LNG)', 'Metals & Agricultural Goods', 'Other'],
      'Cryptocurrency & Digital Assets': ['Bitcoin, Ethereum & Altcoins', 'Regulatory Crackdowns', 'Other'],
      Other: [],
    },
    'Corporate News': {
      'Earnings & Revenue Results': ['Other'],
      'Mergers, Acquisitions & IPOs': ['Other'],
      'CEO Changes & Boardroom Drama': ['Other'],
      Other: [],
    },
    Macroeconomics: {
      'GDP & Economic Growth': ['Other'],
      'Inflation & Interest Rates': ['Other'],
      'Employment & Labor Markets': ['Jobs Reports & Unemployment', 'Wages, Strikes & Union Activity', 'Other'],
      Other: [],
    },
    'Trade & Commerce': {
      'Imports, Exports & Supply Chains': ['Other'],
      'Tariffs & Trade Wars': ['Other'],
      Other: [],
    },
    Other: {},
  },

  Technology: {
    'Artificial Intelligence': {
      'Generative AI': ['Large Language Models (LLMs)', 'Image, Video & Audio Generation', 'Other'],
      'AI Policy, Safety & Ethics': ['Other'],
      'Robotics & Automation': ['Other'],
      Other: [],
    },
    Cybersecurity: {
      'Data Breaches & Hacks': ['Other'],
      'Ransomware & Malware': ['Other'],
      'National Security & Espionage': ['Other'],
      Other: [],
    },
    'Consumer Tech': {
      'Smartphones, PCs & Wearables': ['Other'],
      'Apps, Software & OS Updates': ['Other'],
      'Internet of Things (IoT)': ['Other'],
      Other: [],
    },
    'Social Media & Platforms': {
      'Platform News (Meta, X, TikTok, etc.)': ['Other'],
      'Content Moderation & Censorship': ['Other'],
      'Misinformation & Deepfakes': ['Other'],
      Other: [],
    },
    'Space Tech & Semiconductors': {
      'Chip Design & Fabrication (TSMC, NVIDIA, etc.)': ['Other'],
      'Commercial Space Programs (SpaceX, Blue Origin)': ['Other'],
      Other: [],
    },
    Other: {},
  },

  'World / International': {
    'Conflicts & Wars': {
      'Active Combat Zones': ['Frontline & Battle Reporting', 'Civilian Casualties & Aid Access', 'Other'],
      'Post-Conflict & Reconstruction': ['Other'],
      Other: [],
    },
    Geopolitics: {
      'US-China Relations & Taiwan': ['Other'],
      'NATO, EU & Transatlantic Affairs': ['Other'],
      'Middle East Dynamics': ['Other'],
      'Russia & Former Soviet States': ['Other'],
      Other: [],
    },
    'Humanitarian Crisis': {
      'Refugees & Migration': ['Other'],
      'Famine, Drought & Aid Operations': ['Other'],
      Other: [],
    },
    'Regional News': {
      Europe: ['Other'],
      'Asia-Pacific': ['Other'],
      'Latin America & Caribbean': ['Other'],
      'Sub-Saharan Africa': ['Other'],
      'South Asia': ['Other'],
      Other: [],
    },
    Other: {},
  },

  Health: {
    'Public Health': {
      'Epidemics & Pandemics': ['Disease Surveillance & Outbreaks', 'Vaccine Development & Rollout', 'Other'],
      'Environmental & Social Health Disparities': ['Other'],
      Other: [],
    },
    'Medical Research & Innovation': {
      'Clinical Trials & Drug Approvals': ['Other'],
      'Cancer, Diabetes & Chronic Disease': ['Other'],
      'Gene Therapy & Biotechnology': ['Other'],
      Other: [],
    },
    'Mental Health': {
      'Addiction & Substance Use': ['Other'],
      'Therapy Modalities & Access': ['Other'],
      Other: [],
    },
    'Healthcare Systems & Policy': {
      'Insurance, Coverage & Costs': ['Other'],
      'Hospital Systems & Staffing': ['Other'],
      Other: [],
    },
    Other: {},
  },

  'Science & Environment': {
    'Climate & Environment': {
      'Climate Change': ['Emissions, Carbon & Net Zero Policy', 'Sea Level Rise & Extreme Weather', 'Other'],
      'Biodiversity & Conservation': ['Other'],
      'Energy Transition': ['Solar, Wind & Renewables', 'Nuclear & Hydrogen', 'Other'],
      Other: [],
    },
    'Space & Astronomy': {
      'NASA & Government Space Agencies': ['Other'],
      'Commercial Space Programs': ['Other'],
      'Discoveries & Deep Space': ['Other'],
      Other: [],
    },
    'Research & Discovery': {
      'Biology, Genetics & Evolution': ['Other'],
      'Physics & Cosmology': ['Other'],
      'Earth & Ocean Sciences': ['Other'],
      Other: [],
    },
    Other: {},
  },

  Sports: {
    'Team Sports': {
      Football: {
        NFL: ['Specific Team', 'Other'],
        'NCAA (College Football)': ['Specific Team', 'Other'],
        'HS (High School)': ['Other'],
        Other: [],
      },
      'Basketball (NBA / WNBA / NCAA)': {
        NBA: ['Specific Team', 'Other'],
        WNBA: ['Specific Team', 'Other'],
        "NCAA (Men's Basketball)": ['Specific Team', 'Other'],
        "NCAA (Women's Basketball)": ['Specific Team', 'Other'],
        Other: [],
      },
      Soccer: ['Club Football (EPL, La Liga, UCL, etc.)', 'International (FIFA World Cup, Euros)', 'Other'],
      'Baseball (MLB / NCAA / HS)': {
        MLB: ['Specific Team', 'Other'],
        'NCAA (College Baseball)': ['Specific Team', 'Other'],
        'HS (High School)': ['Other'],
        Other: [],
      },
      Softball: {
        'NCAA (Softball)': ['Specific Team', 'Other'],
        Other: [],
      },
      'Ice Hockey (NHL / NCAA)': ['Other'],
      Other: [],
    },
    'Individual Sports': {
      'Tennis (Grand Slams & Tour)': ['Other'],
      'Golf (PGA Tour, LIV, Majors)': ['Other'],
      'Combat Sports (UFC, Boxing, Wrestling)': ['Other'],
      'Athletics & Track & Field': ['Other'],
      Other: [],
    },
    'Major Multisport Events': {
      'Summer & Winter Olympics': ['Other'],
      'Commonwealth & Pan-American Games': ['Other'],
      Other: [],
    },
    Other: {},
  },

  'Entertainment & Culture': {
    'Film & Television': {
      'Box Office & Theatrical Reviews': ['Other'],
      'Streaming & OTT': ['Originals (Netflix, HBO, Disney+, etc.)', 'Cancellations & Renewals', 'Other'],
      'Awards Season (Oscars, Emmys, BAFTAs)': ['Other'],
      Other: [],
    },
    Music: {
      'Album Releases & Tours': ['Other'],
      'Streaming Charts & Sales': ['Other'],
      'Label Drama, Rights & Royalties': ['Other'],
      Other: [],
    },
    'Celebrity & Pop Culture': {
      'Celebrity News & Feuds': ['Other'],
      'Viral Moments & Meme Culture': ['Other'],
      Other: [],
    },
    'Gaming & Esports': {
      'Game Releases & Reviews': ['Other'],
      'Esports Tournaments & Teams': ['Other'],
      'Industry M&A & Studio News': ['Other'],
      Other: [],
    },
    'Books, Art & Theater': {
      'Publishing & Literary Awards': ['Other'],
      'Visual Art, Museums & Exhibitions': ['Other'],
      Other: [],
    },
    Other: {},
  },

  'Crime & Justice': {
    'Courts & Legal Proceedings': {
      'Criminal Trials': ['High-Profile Cases & Coverage', 'Verdicts, Appeals & Sentencing', 'Other'],
      'Civil Litigation & Class Actions': ['Other'],
      Other: [],
    },
    'Law Enforcement': {
      'Police Actions & Use-of-Force': ['Other'],
      'Major Investigations & Arrests': ['Other'],
      Other: [],
    },
    'Criminal Justice Policy': {
      'Prison Reform & Sentencing Reform': ['Other'],
      'Drug Policy & Decriminalization': ['Other'],
      'Wrongful Convictions & Exonerations': ['Other'],
      Other: [],
    },
    Other: {},
  },

  'Opinion & Analysis': {
    'Editorials & Columns': { Other: [] },
    'Political & Social Commentary': { Other: [] },
    'Economic & Business Analysis': { Other: [] },
    'Reviews & Criticism': {
      'Film, TV & Theater Reviews': ['Other'],
      'Book Reviews': ['Other'],
      'Tech & Product Reviews': ['Other'],
      'Restaurant & Food Reviews': ['Other'],
      Other: [],
    },
    'Investigative Longform': { Other: [] },
    Other: {},
  },
};
